/* eslint-disable jsx-a11y/click-events-have-key-events */

import styled from '@emotion/styled';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FieldHandler from '../../Forms/FieldHandler';
import { center } from '../../../styles/utils';
import Button from '../../Button';
import Triangle from '../../Triangle';
import messages from './EditAddressForm.messages';
import { modalForm } from './EditAddressForm.styles';

const ModalForm = styled.form`
  ${center}
  ${modalForm}
`;

const FormWrapper = styled.div`
  height: calc(100% - 66px);
`;

const FormDivider = styled.hr`
  position: relative;
  border-color: rgb(196, 202, 209);
`;

const CancelEditingTriangle = styled(Triangle)`
  margin-bottom: 0.05rem;
`;

const EditAddressForm = ({ fields, closeForm, handleSubmit }) => (
  <div className="w-100 h-100 pa0 relative">
    <button
      onClick={closeForm}
      className="bn pa0 bg-transparent pointer absolute right-1 top-1"
      tabIndex="0"
      type="button"
    >
      <svg
        height="15"
        viewBox="0 0 15 15"
        width="15"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="m1.42857143.70710678-.72146465.72146465 6.07142857 6.07142857-6.07142857 6.0714286.72146465.7214646 6.07142857-6.07142855 6.0714286 6.07142855.7214646-.7214646-6.07142855-6.0714286 6.07142855-6.07142857-.7214646-.72146465-6.0714286 6.07142857z"
          fill="#d8d8d8"
        />
      </svg>
    </button>
    <ModalForm
      className="w-100 h-100 center bg-light-gray overflow-hidden absolute"
      onSubmit={handleSubmit}
    >
      <FormWrapper className="overflow-y-scroll overflow-x-hidden pa3 pb0">
        {fields.map((field) => (
          <Field
            autoComplete={field.autoComplete}
            key={`address-field-${field.id}`}
            element={field.element}
            type={field.type}
            label={field.title}
            name={field.id}
            labelName={field.id}
            component={FieldHandler}
            validate={field.validate}
            options={field.options}
            isRequired={field.isRequired}
            showOptionalText
          />
        ))}
      </FormWrapper>
      <FormDivider className="mb0 mt0 bt-0 br-0 bl-0" />
      <div className="pa3">
        <div className="dib w-50 tl">
          <button
            className="bn pa0 bg-transparent pointer items-center light-blue no-underline underline-hover ml1 f6 lh-solid lh-title-ns acc-edit-address-form-cancel-editing"
            type="button"
            tabIndex="0"
            onClick={closeForm}
          >
            <CancelEditingTriangle className="mr1" />
            <FormattedMessage {...messages.cancelEditing} />
          </button>
        </div>
        <div className="dib w-50 tr">
          <Button type="submit" className="acc-edit-address-form-save">
            <FormattedMessage {...messages.saveButton} />
          </Button>
        </div>
      </div>
    </ModalForm>
  </div>
);

EditAddressForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  closeForm: PropTypes.func.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default EditAddressForm;
